
'use strict';

import React, {PropTypes} from 'react';

export default function Clip(props) {

  return (
		<svg {...props} width="11px" height="12px" viewBox="0 0 11 12" version="1.1" >
			<title>33A4C9F5-2275-4100-8548-773D79B48C53</title>
			<desc>Created with sketchtool.</desc>
			<defs></defs>
			<g id="2712---Emails" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" stroke-linejoin="round">
				<g id="2712---Emails-3" transform="translate(-458.000000, -580.000000)" stroke="#333333">
					<g id="Group-9" transform="translate(273.000000, 573.000000)">
						<g id="Group-6" transform="translate(175.000000, 0.000000)">
							<g id="Group-4-Copy">
								<g id="Mail_attach-mail">
									<g id="Icons">
										<g id="Group">
											<path d="M16.6993922,17.5941112 L17.116806,16.878195 L18.5764687,14.3707961 L20.0361313,11.8633971 C20.2366957,11.5189788 20.3584057,11.1483272 20.4055468,10.7742906 C20.452688,10.4002541 20.4269747,10.0228325 20.3326923,9.663182 C20.2384099,9.30353146 20.0755585,8.96165188 19.850995,8.65954543 C19.6264315,8.35743897 19.3392988,8.09510563 18.9947396,7.89370133 C18.6510375,7.69229703 18.281622,7.5712852 17.908778,7.52304971 C17.535934,7.47566046 17.1588045,7.5018938 16.7996744,7.59667229 C16.4405442,7.69145079 16.0994134,7.85392821 15.7985669,8.07987338 C15.4968633,8.3049723 15.235444,8.59353898 15.0348796,8.93795726 L14.4091875,10.0126777 L13.3652244,11.8024681 L12.3229755,13.5931046 L11.2807267,15.3837412 C11.1375889,15.6299961 11.0510205,15.8940219 11.016736,16.1614326 C10.9824515,16.4288434 11.001308,16.6987929 11.0690199,16.9552025 C11.1367318,17.2124585 11.252442,17.4561746 11.412722,17.6719649 C11.5730021,17.8877552 11.7787091,18.0756198 12.0238433,18.2186337 C12.2698346,18.362494 12.5329681,18.4488101 12.7995301,18.4835058 C13.0660921,18.5173553 13.3352255,18.4987381 13.5915021,18.4310391 C13.8477788,18.3633402 14.0911987,18.2474058 14.3071911,18.0857746 C14.5223263,17.9249897 14.7091769,17.7193542 14.8531718,17.4730993 L15.8954206,15.6824627 L16.9376695,13.8918262 L16.9548117,13.8622079 L16.3119773,14.9665466 L16.9376695,13.8918262 L17.5633616,12.8171057 L18.1890538,11.7423853 C18.2747651,11.5942939 18.3270489,11.4360476 18.3476196,11.2752627 C18.3681903,11.115324 18.3570479,10.9528465 18.3159065,10.7988315 C18.2756222,10.6448164 18.2061961,10.4984175 18.1093423,10.3689433 C18.0133457,10.2394691 17.8899215,10.1269196 17.7424982,10.0406035 C17.5950748,9.95428738 17.436509,9.90266695 17.2770861,9.88151104 C17.116806,9.86120136 16.9556688,9.87220244 16.8022457,9.91282179 C16.6479654,9.95344115 16.5022563,10.0228325 16.3728323,10.1193035 C16.2434083,10.2157745 16.1311266,10.339325 16.0454153,10.4874164 L15.4197232,11.5621369 L14.794031,12.6368573 L13.5426467,14.785452" id="Shape-Copy"></path>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
  );

}



// WEBPACK FOOTER //
// ./shared/common/svgs/Clip.js